module.exports = __webpack_public_path__ + "static/baum-d4f149cf8224726e982dcb9d053a3133.png";